export default __webpack_public_path__ + "static/media/slider-cia-1.a27c99bb.jpg";